import {getAccessToken} from "../extensions/userInfoExtension";
import axios from "axios";
import React from "react";

// Constants of service
const juvolyWssUrl = "wss://services.juvoly.nl/api/v2/socket";

export const getSession = async () => {
  const config = {
    method: 'get',
    maxBodyLength: Infinity,
    url: `/prod/juv-session?v2=true`,
    headers: {
      'accept': '*/*',
      'Access-Control-Allow-Origin': '*',
      'Authorization': `Bearer ${getAccessToken()}`
    }
  }

  return await axios.request(config)
    .then((response) => {
      return JSON.parse(response.data);
    })
    .catch((error) => {
      console.error(error);
      return null;
    });
}


export const startTranscription = async (
  {
    mediaStream,
    model,
    onWsMessage,
    onWsOpen,
    onWsError,
    onWsClose,
  }
) => {
  let ws; // scoped for use in `stop`
  let recorder;

  const stop = () => {
    if (ws?.readyState === WebSocket.OPEN || ws?.readyState === WebSocket.CONNECTING) {
      ws.close();
    }
  };


  try {
    const wsUrl = `${juvolyWssUrl}/${model ?? `generic`}`;
    const session = await getSession();
    const subprotocols = ["v2.juvoly", session.clientId, session.sessionId];

    ws = new WebSocket(wsUrl, subprotocols);

    ws.onopen = () => {
      const recorder = new MediaRecorder(mediaStream);
      recorder.ondataavailable = ({data}) => {
        if (ws.readyState === WebSocket.OPEN) {
          ws.send(data);
        }
      };

      recorder.start(250);
      onWsOpen?.();
    };

    ws.onmessage = (event) => {
      const result = JSON.parse(event.data);

      if (result.type === "transcript") {
        const processedResult = {
          ...result,
          conversation: {
            ...result.utterance,
            timestamp: Date.now()
          },
        };
        delete processedResult.utterance;
        delete processedResult.type;

        onWsMessage?.(processedResult);
      }
    };

    ws.onclose = (event) => {
      console.log('Connection closed');
      onWsClose?.(event);
    };

    ws.onerror = (event) => {
      console.error(event);
      stop();
      onWsError?.(event);
      // TODO: retry connection..!
    };

  } catch (error) {
    console.error("Fout bij starten van transcriberen:", error);
  }


  return {stop};
}